import PropTypes from 'prop-types';
import { Button, Card } from 'react-bootstrap';
import { formatDate } from '../services/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { far } from '@fortawesome/pro-regular-svg-icons';

import { messages as jobmessages } from '../views/Job/Job.messages';
import { JOB_ENERGYTYPE } from '../services/job';
import { messages } from '../views/Job/Job.messages';
import { jobFetchJob } from '../services/job';
import useServing from '../hooks/useServing';
import ServingModal from './ServingModal';

const ServingCard = (props) => {
    const lng = props.intl.formatMessage;
    const { submitSignature } = useServing(props.job);

    /**
     *  Save user's signature for a serving.
     *  Signing is possible only with strong authentication.
     */
    const signServing = async () => {
        props.toggleLoading(true, lng(messages.actionSaving));

        try {
            const response = await submitSignature(props.job.dpid);

            // update job data on success
            jobFetchJob(response.data.jobid).then(response => {
                // update the job and show success to user
                props.onUpdateJob(response);
                props.handleAlertDialog(lng(messages.titleThankYou) + ". " + lng(messages.changesSaved), 'success');

                // hide the serving modal
                props.onHideServingModal();
                // loading animation off
                props.toggleLoading(false);
            });

        } catch (error) {
            if (error.response?.data.title === "Invalid UserRequest") {
                // signing a serving is not allowed if user is not logged in (requires strong authentication)
                props.handleAlertDialog(lng(messages.authErrorShort) + ". " + lng(messages.strongAuthenticationNeeded), 'danger');
                props.onDisableServingButton(true);
            } else if (noServingResponse404(error.response)) {
                // don't allow signing
                props.onDisableServingButton(true);
            } else {
                // request failed, show alertdialog
                props.handleAlertDialog(lng(messages.titleSavingFailed) + ". " + lng(messages.somethingWentWrongTryAgain), 'danger');
            }

            props.onHideServingModal();
            // loading animation off
            props.toggleLoading(false);
        }
    }

    /**
     * No serving if status is 404 with specific messages
     * 404 when no match found, no changes to UI
     *
     * @param response
     * @returns
     */
    const noServingResponse404 = (response) => {
        return response?.status === 404 && (
            response?.data.title === 'No serving found' ||
            response?.data.title === 'Address data not found, serving not allowed'
        );
    }

    // serving details  
    return (
        <>
            <Card id='serving-info' className='fullwidth-mobile serving-info-desktop grey-bottom-border-mobile'>
                <Card.Body>
                    <h3>{lng(jobmessages.servingPanelHeader)}</h3>
                    <ul className='list-unstyled'>
                        {props.servingData?.serving_need_signature ? (
                            <li id='document-for-signing'>
                                {/* open serving modal, if user is authenticated */}
                                {props.disableServingButton ? (
                                    <p><span className='alert-icon'><FontAwesomeIcon icon={far.faCircleExclamation} /> {lng(jobmessages.documentToSign)}</span></p>
                                ) : (
                                    <Button id='card-serving-button' className='ps-0 blue-text' variant='tertiary' onClick={() => props.onShowServingModal()}>
                                        <FontAwesomeIcon icon={far.faCircleExclamation} /> {lng(jobmessages.documentToSign)}
                                    </Button>
                                )}
                                <span className='label d-block'>{lng(jobmessages.moreInformation)}</span>
                                <p>{props.job.energytype === JOB_ENERGYTYPE.HEATING ? lng(jobmessages.servingInformationHeating) : lng(jobmessages.servingInformation)} </p>
                            </li>
                        ) : (
                            <li id='serving-signed-date'>
                                <p><FontAwesomeIcon icon={far.faCircleExclamation} className='neutral-icon' /> {lng(jobmessages.signatureReceived)}</p>
                                <span className='label'>{lng(jobmessages.signatureDate)}</span>
                                <p>{formatDate(props.servingData.served_at)}</p>
                            </li>

                        )}

                    </ul>
                </Card.Body>
            </Card>

            {props.isAuthed && props.servingData?.serving_need_signature && (
                <ServingModal
                    job={props.job}
                    show={props.showServingModal}
                    signServing={signServing}
                    hide={props.onHideServingModal}
                    {...props}
                />
            )}
        </>
    );
};

ServingCard.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object,
    'servingData': PropTypes.object,
    'toggleLoading': PropTypes.func,
    'onUpdateJob': PropTypes.func,
    'handleAlertDialog': PropTypes.func,
    'onDisableServingButton': PropTypes.func,
    'disableServingButton': PropTypes.bool,
    'showServingModal': PropTypes.bool,
    'onShowServingModal': PropTypes.func,
    'onHideServingModal': PropTypes.func,
    'isAuthed': PropTypes.bool
};

export default ServingCard;